<template>
    <!-- A card on the report designs' page grid. `columns: 2` on a section
         sets its fields side by side (a field with `fullWidth` spans the row). -->
    <report-card    v-if="variant === 'cards'"
                    :title="title"
                    :columns="columns"
    >
        <slot></slot>
    </report-card>

    <!-- No chrome: just the fields, for a host that supplies its own card
         (the group report page's Report Details). -->
    <div    v-else-if="variant === 'bare'"
            class="flex flex-col">
        <slot></slot>
    </div>

    <section    v-else
                class="mb-8">
        <h3 class="m-0 mb-1 p-0 text-left text-base font-semibold text-gray-900">
            {{ title }}
        </h3>

        <p  v-if="description"
            class="m-0 mb-3 text-left text-sm text-gray-500">
            {{ description }}
        </p>

        <div class="report-settings-rows border-t border-gray-200 pt-1">
            <slot></slot>
        </div>
    </section>
</template>

<style>
/* Divider between rows, but not above a static row: those carry their own card
   background, and a rule across the card reads as a rendering bug. Written as
   CSS rather than Tailwind's `divide-y` so the :not() can win on specificity.
   Unscoped because the rows are the roots of child field components. */
.report-settings-rows > * + *:not(.report-settings-static) {
    border-top: 1px solid rgb(229 231 235);
}
</style>

<script>
import ReportCard from "./ReportCard.vue";

export default {
    name: "ReportSettingsSection",
    // A bare section's fields use the compact label (see ReportFieldRow).
    provide() {
        return {
            reportFieldRowCompact: this.variant === 'bare',
        }
    },
    components: {ReportCard},
    props: {
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            default: null,
        },
        // 'list', 'cards' or 'bare'; see ReportSettingsPanel.
        variant: {
            type: String,
            default: 'list',
        },
        // Fields per row in the card style.
        columns: {
            type: Number,
            default: 1,
        },
    },
}
</script>
